import { Module } from '@nu-art/ts-common';
import { apiWithBody } from '@nu-art/thunderstorm-frontend/index';
import { ApiDef_DataMigration } from '@app/data-migration-shared';
class ModuleFE_DataMigration_Class extends Module {
    _v1;
    constructor() {
        super('ModuleFE_DataMigration');
    }
    init() {
        const _v1 = {
            preview: apiWithBody(ApiDef_DataMigration._v1.preview),
            dryRun: apiWithBody(ApiDef_DataMigration._v1.dryRun),
            execute: apiWithBody(ApiDef_DataMigration._v1.execute),
        };
        // @ts-ignore -- init-time assignment
        this._v1 = _v1;
    }
}
export const ModuleFE_DataMigration = new ModuleFE_DataMigration_Class();
//# sourceMappingURL=ModuleFE_DataMigration.js.map